export const iconFontAwesomeTextformattingSquareCheck = (
	<i className="fa-solid fa-square-check"></i>
);
